<button
  mat-button
  color="primary"
  ixTest="save-debug"
  (click)="onSaveDebug()"
>
  {{ 'Save Debug' | translate }}
</button>
